import {updateLabelConfig} from '../../../data/labelInfos/index.js'
import ConfigSelect from './ConfigSelect.js'
import {
  CANADA_POST,
  ENDICIA,
  NEWGISTICS,
  PITNEY,
  PITNEY_MERCHANT,
  PITNEY_PRESORT,
  USPS_SHIP,
} from '../../../common/constants/ShipperNames.js'
import {useLabelConfigContext} from '../LabelConfigContext.js'
import {
  ADDITIONAL_SHIPPER_DEPENDENT_PROPERTIES_FUNC,
  defaultValidLabelPropertiesFunc,
} from './useLabelProperty.js'

const VALID_SHIPPER_TYPES = [
  CANADA_POST,
  ENDICIA,
  NEWGISTICS,
  PITNEY,
  PITNEY_MERCHANT,
  PITNEY_PRESORT,
  USPS_SHIP,
]

function labelPropertiesFunc(shipperType) {
  return VALID_SHIPPER_TYPES.includes(shipperType)
    ? [`${shipperType}__nondelivery_option`]
    : []
}

export default function NondeliveryOption() {
  const {labelInfoID, shipperType, onChange} = useLabelConfigContext()
  const propertySpecs = NondeliveryOption.propertySpecList[0]
  const [labelProperty] = propertySpecs.labelPropertiesFunc(
    shipperType,
    labelInfoID,
  )

  return (
    <ConfigSelect
      label="Nondelivery Option"
      onChange={(value) => {
        updateLabelConfig(labelInfoID, {
          [labelProperty]: value,
        })

        onChange()
      }}
      required={CANADA_POST === shipperType}
      labelProperty={labelProperty}
      propertySpecs={propertySpecs}
      shipperOptionsProperty="nondelivery"
    />
  )
}

NondeliveryOption.propertySpecList = [
  {
    validShipperTypes: VALID_SHIPPER_TYPES,
    labelPropertiesFunc: labelPropertiesFunc,
    dependentPropertiesFunc: ADDITIONAL_SHIPPER_DEPENDENT_PROPERTIES_FUNC,
    validLabelPropertiesFunc: defaultValidLabelPropertiesFunc,
  },
]
